import axios from 'axios'; 
import Cookies from 'js-cookie';
 

export const requestOTP = async (email) => {
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/verify`, { email });
    console.log('OTP request successful:', response.data);
  } catch (error) {
    console.error('Error requesting OTP:', error);
    throw error; 
  }
};

export const signUp = async (formData) => {
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/register`, formData);
    return response.data;
  } catch (error) {
    console.log("Error while registration:" ,error)
    throw new Error("Error while Registration",error)
   
  }
};

// Function to handle the login request and response logic
export const logIn = async (formData) => {
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/login`, formData);
    return response.data; // Return the response data which includes access_token
  } catch (error) {
    throw new Error(`Error logging in: ${error.message}`);
  }
};


export const submitContactForm = async (formData, onSuccess, onError) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      onSuccess();
    } else {
      onError();
    }
  } catch (error) {
    console.error('Error occurred while submitting form:', error);
    onError();
  }
};


// Create User in the database after submitting the OTP
export const submitOtp = async (payload) => {
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/verify`, payload);
    console.log(response)
    const { code, access_token } = response.data;

    if (code === 200) {
      Cookies.set('jwtToken', access_token);
      console.log('JWT Token saved as cookie:', access_token);
      return { success: true };
    } else {
      console.log("Error verifying OTP, received code:", code);
      return { success: false };
    }
  } catch (error) {
    console.error("Error", error);
    return { success: false };
  }
};


